module.exports = __webpack_public_path__ + "static/img/jp8.bcb2d75a.png";